<template>
  <b-modal ref="modal" :title="dialog_title" hide-footer>
    <div class="form-group row">
      <div class="col">
        <input type="text" class="form-control" id="family_name" v-model="name">
        <label for="family_name" class="wabident-info">Nombre</label>
      </div>
      <div class="col">
        <input type="text" class="form-control" id="family_category" v-model="category">
        <label for="family_category" class="wabident-info">Categoría</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col d-flex justify-content-around" style="gap:10px">
        <button v-if="is_editing" type="button" class="btn btn-wabident red" @click="onDelete" :disabled="is_loading"><i
            class="fas fa-trash"></i> Borrar</button>
        <button type="button" class="btn btn-wabident" @click="onSubmit" :disabled="is_loading">{{ btn_title }}</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      family: null,
      name: null,
      category: null,
      is_loading: false,
    };
  },
  computed: {
    is_editing() {
      return this.family != null;
    },
    dialog_title() {
      return this.is_editing ? 'Editar Familia' : 'Crear Familia';
    },
    btn_title() {
      return this.is_editing ? 'Modificar' : 'Crear';
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  methods: {
    showNew() {
      this.is_loading = false;
      this.family = null;
      this.name = null;
      this.category = null;
      this.$refs.modal.show();
    },
    showEdit(family) {
      this.family = family;
      this.is_loading = false;
      this.name = this.family.name;
      this.category = this.family.category;
      this.$refs.modal.show();
    },
    onSubmit() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;

      const uri = this.is_editing ? `/family/${this.family.id}` : `/family`;
      let params = {
        name: this.name,
        category: this.category
      };

      if (this.is_editing) {
        params['_method'] = 'patch';
      }

      axios.post(uri, params).then((response) => {
        let data = response.data;
        if (data.error) {
          this.errorwindow.show('Error', data.error);
        } else {
          this.$emit('submit');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        console.log(error);
        this.errorwindow.show('Error', 'Error modificando Familia. Por favor, consulte con el Administrador');
      }).then(() => {
        this.is_loading = this.false;
      });

    },
    onDelete() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;
      const uri = `/family/${this.family.id}`;

      let params = {
        _method: 'delete',
      };

      axios.post(uri, params).then((response) => {
        let data = response.data;
        if (data.error) {
          this.errorwindow.show('Error', data.error);
        } else {
          this.$emit('submit');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        console.log(error);
        this.errorwindow.show('Error', 'Error borrando Familia. Por favor, consulte con el Administrador');
      }).then(() => {
        this.is_loading = false;
      });
    },
  }
}
</script>
